module.exports = __webpack_public_path__ + "static/media/full-arrow.55f91cd8.svg";